<template>
  <div class="login-form">
    <div class="item">
      <input
        type="text"
        name="name"
        v-model="login.phoneNum"
        placeholder="请输入您的帐号"
        autocomplete="off"
        class="name"
      />
      <img class="icon" src="~@/assets/img/icon-phone.png" alt="" />
    </div>
    <div class="item">
      <input
        type="password"
        name="password"
        v-model="login.password"
        placeholder="请输入您的密码"
        autocomplete="off"
        class="password"
      />
      <img class="icon" src="~@/assets/img/icon-password.png" alt="" />
    </div>
    <div class="control">
      <div class="remember">
        <wd-checkbox v-model="remember" shape="square" style="margin-left: 5px"
          ><font style="color: #3c3c3c">记住密码</font></wd-checkbox
        >
      </div>
      <div class="forget" @click="toForget">忘记密码？</div>
    </div>
    <div class="submit" @click="doLogin">
      <button
        :disabled="disabled"
        :style="disabled ? { backgroundColor: '#666666' } : {}"
      >
        {{ disabled ? "登录中" : "登录" }}
      </button>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";

export default {
  name: "LoginFrom",
  data() {
    return {
      disabled: false,
      login: {
        phoneNum: "",
        password: "",
      },
      remember: false,
    };
  },
  mounted() {
    if (localStorage.getItem("phoneNumRem")) {
      this.login.phoneNum = localStorage.getItem("phoneNumRem");
      this.remember = true;
    }
    if (localStorage.getItem("passwordRem")) {
      this.login.password = localStorage.getItem("passwordRem");
    }
  },

  methods: {
    doLogin() {
      if (!this.login.phoneNum || !this.login.password) {
        this.$toast("用户名或密码不能为空！");
      } else {
        this.login.password = md5.hex(this.login.password);
        this.disabled = true;
        this.$http
          .post("/external/appUser/login", this.login)
          .then((res) => {
            if (res.code === 200 ) {
              if(res.user.phoneNum !== this.login.phoneNum) {
                this.$toast.error("登录失败！");
                this.disabled = false;
              }else {
                this.$toast.success("登录成功！");
                setTimeout(() => {
                  localStorage.setItem("appUserId", res.user.appUserId);
                  localStorage.setItem("phoneNum", res.user.phoneNum);
                  if (res.user.roleWxPayChannel) {
                    localStorage.setItem(
                        "roleWxPayChannel",
                        res.user.roleWxPayChannel
                    );
                  }
                  if (res.user.roleId) {
                    localStorage.setItem("roleKey", res.user.roleId);
                  } else {
                    localStorage.removeItem("roleKey");
                  }
                  if (res.user.rolePhoneNum) {
                    // console.log("res.user.rolePhoneNum", res.user.rolePhoneNum);
                    localStorage.setItem("rolePhoneNum", res.user.rolePhoneNum);
                  } else {
                    localStorage.removeItem("rolePhoneNum");
                  }
                  if (res.user.roleIds) {
                    localStorage.setItem("roleIds", res.user.roleIds);
                  } else {
                    localStorage.removeItem("roleIds");
                  }
                  // console.log("roleIds", res.user.roleIds);

                  if (
                      res.user.roleIds &&
                      res.user.roleIds.includes(res.user.roleId + "")
                  ) {
                    localStorage.setItem("showControl", "true");
                  } else {
                    localStorage.setItem("showControl", "false");
                  }
                  if (this.remember) {
                    localStorage.setItem("phoneNumRem", this.login.phoneNum);
                    localStorage.setItem("passwordRem", this.login.password);
                  } else {
                    localStorage.removeItem("phoneNumRem");
                    localStorage.removeItem("passwordRem");
                  }
                  this.disabled = false;
                  setTimeout(() => {
                    this.$router.push("/home");
                  }, 500);
                }, 1000);
              }
            } else {
              this.disabled = false;
              this.$toast.error(res.msg);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    toForget() {
      this.$emit("handleTabClick", "forget");
    },
  },
};
</script>

<style lang="less" scoped></style>
